import type { QuickSuggestion, ContactCTA } from '@brochure/shared'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'haircare',
    labelKey: 'chatbot.suggestions.haircare.label',
    messageKey: 'chatbot.suggestions.haircare.message',
  },
  {
    id: 'philosophy',
    labelKey: 'chatbot.suggestions.philosophy.label',
    messageKey: 'chatbot.suggestions.philosophy.message',
  },
  {
    id: 'salon',
    labelKey: 'chatbot.suggestions.salon.label',
    messageKey: 'chatbot.suggestions.salon.message',
  },
  {
    id: 'partner',
    labelKey: 'chatbot.suggestions.partner.label',
    messageKey: 'chatbot.suggestions.partner.message',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 * Leave empty to hide CTAs entirely.
 */
export const contactCTAs: ContactCTA[] = []
